import { StepStatus, Stepper, StepperStep } from "@dgs/core";
import { FormikErrors, useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import styled from "styled-components";
import { EventFormValues } from "../../types/event";
import { useFilteredEventSteps } from "../eventSteps";

export type EventStepKey = "base-data" | "address" | "users" | "participation" | "planned-cost" | "details";

export interface EventStep extends StepperStep {
	key: EventStepKey;
	isValid: (errors: FormikErrors<EventFormValues>) => boolean;
}

const StyledStepper = styled(Stepper)`
	flex-wrap: wrap;
	row-gap: ${({ theme }) => theme.spacing(4)};
`;

const getStatus = (index: number, currentIndex: number, isValid: boolean): StepStatus => {
	if (index === currentIndex) {
		return "active";
	}

	if (index < currentIndex) {
		if (isValid) {
			return "done";
		} else {
			return "error";
		}
	}

	return "inactive";
};

export const EventStepper: FC = () => {
	const { pathname } = useLocation();
	const { t } = useTranslation();
	const formik = useFormikContext<EventFormValues>();
	const { filteredSteps } = useFilteredEventSteps(formik.values.eventType);

	const indexOfActiveStep = filteredSteps.findIndex((step) => pathname.includes(step.key));

	return (
		<StyledStepper
			currentStepIndex={indexOfActiveStep}
			steps={filteredSteps.map((s, index) => ({
				...s,
				label: t(s.label as string),
				status: getStatus(index, indexOfActiveStep, s.isValid(formik.errors)),
			}))}
		></StyledStepper>
	);
};
